module.exports = __webpack_public_path__ + "static/Tedx_edit-a5b9b715427b92f1a7ef625eeec72d8d.gif";